import { color } from './color';
export var solid = color.theme.divider.solid;
export var gradient = {
    horizontal: color.theme.divider.gradientHorizontal,
    vertical: color.theme.divider.gradientVertical
};
//# sourceMappingURL=divider.js.map